namespace Portico.Services {

	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import psge = apigateway.enums;
	import psgm = apigateway.models;

	export interface IConversionService {
		convertGetCaseResponseModelToAccount: (response: psgm.GetCaseResponseModel) => pme.Account;
	}

	@Service('app', 'conversionService')
	@Inject('serverConstants')
	export class ConversionService implements IConversionService {
		constructor() {
        }

		convertGetCaseResponseModelToAccount(response: psgm.GetCaseResponseModel): pme.Account {
			const account = new pme.Account(response.accountData);

			account.id = null;
			account.assignedUser = null;
			account.displayId = null;
			account.partyId = null;
			account.securePartyId = null;
			account.accountSessions = [];
			account.documentRelationships = [];
			account.linkedPayors = [];
			account.notes = [];
			account.optionalServices = [];
			account.payorRelationships = [];
			account.pharmacyRelationships = [];
			account.prescriberRelationships = [];
			account.siteRelationships = [];
			account.tasks = [];

			account.accountAddresses.forEach(aa => {
				aa.id = null;
			});

			account.contacts.forEach(c => {
				c.id = null;
			});

			account.phoneNumbers.forEach(pn => {
				pn.id = null;
			});

			account.patient = new pme.Patient(response.patientData);

			// account.patient.id = null;
			account.patient.ssn = response.ssn;

			account.patient.addresses.forEach(a => {
				a.id = null;
			});

			account.patient.contacts.forEach(c => {
				c.id = null;

				c.addresses.forEach(a => {
					a.id = null;
				});

				c.emailAddresses.forEach(ea => {
					ea.id = null;
				});

				c.phoneNumbers.forEach(pn => {
					pn.id = null;
				});

				c.webAddresses.forEach(wa => {
					wa.id = null;
				});
			});

			account.patient.emailAddresses.forEach(ea => {
				ea.id = null;
			});

			account.patient.phoneNumbers.forEach(pn => {
				pn.id = null;
			});

			if (response.diagnosisData) {
				const diagnosisSession = account.getDiagnosisSession();
				diagnosisSession.ids = _.map(response.diagnosisData, d => d.diagnosisId);
			}

			if (response.payorData) {
				response.caseData.payors.forEach(pr => {
					pr.caseRelations.forEach(or => {
						const payor = _.find(response.payorData, pd => pd.payorData.payorType === <pm.Gateway.PayorType><unknown>pr.roleType && pd.payorData.payorId === or.partyRoleId);

						if (payor) {
							const p = new pme.Payor(payor.payorData);

							p.id = null;

							p.addresses.forEach(a => {
								a.id = null;
							});

							p.emailAddresses.forEach(ea => {
								ea.id = null;
							});

							p.phoneNumbers.forEach(pn => {
								pn.id = null;
							});

							p.webAddresses.forEach(wa => {
								wa.id = null;
							});

							account.payorRelationships.push(new pme.PayorRelationship(<pme.PayorRelationship>{
								order: or.coverageOrder,
								payor: p,
								payorBenefit: new pme.PayorBenefit(payor.benefitData),
								role: <psge.PayorType><unknown>pr.roleType
							}));
						}
					});
				});
			}

			if (response.pharmacyData) {
				response.caseData.pharmacies.forEach(pr => {
					const pharmacy = _.find(response.pharmacyData, pd => pd.pharmacyData.pharmacyId === pr.partyRoleId);

					if (pharmacy) {
						const p = new pme.Pharmacy(pharmacy.pharmacyData);

						p.id = null;

						p.addresses.forEach(a => {
							a.id = null;
						});

						p.contacts.forEach(c => {
							c.id = null;

							c.addresses.forEach(a => {
								a.id = null;
							});

							c.emailAddresses.forEach(ea => {
								ea.id = null;
							});

							c.phoneNumbers.forEach(pn => {
								pn.id = null;
							});

							c.webAddresses.forEach(wa => {
								wa.id = null;
							});
						});

						p.emailAddresses.forEach(ea => {
							ea.id = null;
						});

						p.phoneNumbers.forEach(pn => {
							pn.id = null;
						});

						p.webAddresses.forEach(wa => {
							wa.id = null;
						});

						const pocs = _.map(pharmacy.pointOfContactData, poc => new pme.PointOfContact(poc));

						pocs.forEach(poc => {
							poc.id = null;
						});

						account.pharmacyRelationships.push(new pme.PharmacyRelationship(<pme.PharmacyRelationship>{
							isPrimary: pr.isPrimary,
							pharmacy: p,
							pointOfContacts: pocs
						}));
					}
				});
			}

			if (response.prescriberData) {
				response.caseData.prescribers.forEach(pr => {
					const prescriber = _.find(response.prescriberData, pd => pd.prescriberId === pr.partyRoleId);

					if (prescriber) {
						const p = new pme.Prescriber(prescriber);

						p.id = null;

						p.addresses.forEach(a => {
							a.id = null;
						});

						p.emailAddresses.forEach(ea => {
							ea.id = null;
						});

						p.phoneNumbers.forEach(pn => {
							pn.id = null;
						});

						p.prescriberLicenses.forEach(pl => {
							pl.prescriberLicenseId = null;
						});

						account.prescriberRelationships.push(new pme.PrescriberRelationship(<pme.PrescriberRelationship>{
							isPrimary: pr.isPrimary,
							prescriber: p
						}));
					}
				});
			}

			if (response.prescriptionData) {
				const prescriptions = [];

				response.caseData.prescriptions.forEach(cp => {
					const prescription = _.find(response.prescriptionData, pd => pd.id === cp.prescriptionId);

					if (prescription) {
						prescriptions.push(new pme.Prescription(prescription));
					}
				});

				if (prescriptions.length > 0) {
					const ordered = _.orderBy(prescriptions, ['createdOn'], ['desc']);
					const first = ordered[0];
					first.id = null;
					account.prescriptions.push(first);
				}
			}

			if (response.siteData) {
				response.caseData.sites.forEach(sr => {
					const site = _.find(response.siteData, sd => sd.siteData.siteId === sr.partyRoleId);

					if (site) {
						const s = new pme.Site(site.siteData);

						s.id = null;

						s.addresses.forEach(a => {
							a.id = null;
						});

						s.contacts.forEach(c => {
							c.id = null;

							c.addresses.forEach(a => {
								a.id = null;
							});

							c.emailAddresses.forEach(ea => {
								ea.id = null;
							});

							c.phoneNumbers.forEach(pn => {
								pn.id = null;
							});

							c.webAddresses.forEach(wa => {
								wa.id = null;
							});
						});

						s.emailAddresses.forEach(ea => {
							ea.id = null;
						});

						s.phoneNumbers.forEach(pn => {
							pn.id = null;
						});

						const pocs = _.map(site.pointOfContactData, poc => new pme.PointOfContact(poc));

						pocs.forEach(poc => {
							poc.id = null;
						});

						account.siteRelationships.push(new pme.SiteRelationship(<pme.SiteRelationship>{
							isPrimary: sr.isPrimary,
							site: s,
							pointOfContacts: pocs
						}));
					}
				});
			}

			if (response.surveyData) {
				response.surveyData.forEach(sd => {
					const surveySession = account.getSurveySession(sd.sessionData.surveyId);
					const questionIds = _.uniq(_.map(sd.valueData, 'questionId'));
					questionIds.forEach(q => {
						const answers = _.filter(sd.valueData, { 'questionId': q });
						const answerIds = _.map(answers, 'answerId');
						const answerValue = _.get(answers, '[0].answerValue', '');
						surveySession.setSurveySessionAnswers(q, answerIds, answerValue);
					});
				});
			}

			return account;
		}
    }
}